import { BACKEND_URL } from "../api";

export const getImageUrl = (url = "") => {
    if (!url) return null;

    const cleanUrl = url.replace(/\\/g, "/");

    if (cleanUrl.startsWith("http")) {
        return cleanUrl;
    }

    return `${BACKEND_URL}/${cleanUrl}`;
};